<template>
	<div>
		<div class="border-bottom pb-3 mb-6">
            <div class="display-3 kp-title">Users</div>
        </div>
        <div class="border-bottom pb-3 mb-7">
		    <div class="d-flex align-items-center mb-5">
		        <h3 class="card-title mb-0 text-muted">
		            All Users
		        </h3>
		    </div>
		    <div class="row">
		        <div class="col-12">
		            <table class="table card-table table-edge">
		                <thead>
		                    <tr>
		                        <th>
		                            Name
		                        </th>
		                        <th>
		                            Email
		                        </th>
		                        <th>
		                            ID
		                        </th>
		                        <th>
		                            Created
		                        </th>
		                    </tr>
		                </thead>
		                <tbody>
		                    <tr v-for="item in items">
		                        <td>
		                            <span class="text-muted mr-3">
		                                <i class="fe fe-user">
		                                </i>
		                            </span>
		                            <router-link :to="{name: 'user-details', params: {id: item.id}}">
		                            	{{`${item.fname} ${item.lname}`}}
		                            </router-link>
		                        </td>
		                        <td>
		                            {{item.email}}
		                        </td>
		                        <td>
		                            {{item.id}}
		                        </td>
		                        <td>
		                            {{item.createdAt | df}}
		                        </td>
		                    </tr>		                    	                    
		                </tbody>
		            </table>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import {HTTP} from '@/components/HTTP.js'
	import DateFormat from '@/components/DateFilter.js'

	export default {
		created: function(){
			this.fetch()
		},
		filters: {
			df: DateFormat
		},
		data: function(){
			return {
				items:[]
			}
		},
		methods: {
			fetch: function(){
				HTTP.get('e/observers')
	  			.then((res) => {
	  				if (res.data.status) {
	  					this.items = res.data.data.observers;
	  				}	  				
	  			})
	  			.catch((e) => {
	  				console.log("Error response", e);
	  			})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/users/Index.vue